export enum ScorecardDisplayType {
  punchcardView = 0,
  numberView = 1,
  progressBarView = 2,
  milestoneProgressBarView = 3,
  soloAction = 4,
  singleAction = 5,
  streakView = 6,
}
